import { FunctionComponent } from 'react';

const CardTitle: FunctionComponent = ({ children }) => {
  return <p className="fs-20 text-dark">{children}</p>;
};
export default CardTitle;
